module.exports = __webpack_public_path__ + "static/media/interview_o2.12e01f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Problems/img/interview_o2.png
// module id = 263
// module chunks = 0